import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { AdvanceService } from 'src/app/shared/services/advance.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { map, tap } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';
import { Employee } from 'src/app/shared/models/employee.model';
import { Advance } from 'src/app/shared/models/advance.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-advance-edit',
  templateUrl: './advance-edit.component.html'
})
export class AdvanceEditComponent implements OnInit {
  employees$: Observable<Employee[]>;
  editAdvanceFormGroup: FormGroup;
  hasStaticAdvance$;
  currentUserId;
  advance$;
  advanceId;
  constructor(
    private employeeService: EmployeeService,
    private advanceService: AdvanceService,
    private toastrService: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(paramAsMap => {
      this.advanceId = +paramAsMap.get('id');
      this.advance$ = this.advanceService.fetchAdvance(this.advanceId).pipe(
        tap(advance => {
          this.patchFormGroup(advance);
        }),
      );
    });
    this.currentUserId = this.userService.getCurrentUserId();
    this.createFormGroup();
    this.employees$ = this.employeeService.activeEmployees$;
  }

  createFormGroup() {
    this.editAdvanceFormGroup = this.fb.group({
      name: [undefined, [Validators.required]],
      value: [undefined, [Validators.required]],
    });
  }

  patchFormGroup(advance: Advance) {
    this.editAdvanceFormGroup.patchValue({
      ...advance,
    });
  }



  submit() {

    const advance = Advance.adapt(this.editAdvanceFormGroup.value);

    this.advanceService.updateAdvance(advance, this.advanceId).subscribe(_ => {
      this.toastrService.success('Poprawnie zaktualizowano zaliczkę');
      this.router.navigate(['advances/employees']);
    },
      _ => this.toastrService.error('Nie udało się zaktualizować zaliczki')
    );
  }
}
